import { useState, useEffect } from 'react';
import dayjs from 'dayjs';

const useCountdown = (targetDate: Date) => { // return in seconds
    const calculateTimeLeft = () => {
        const difference = +new Date(targetDate) - +new Date();
        let timeLeft = 0;

        if (difference > 0) {
            timeLeft = Math.floor(difference / 1000);
        }

        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearTimeout(timer);
    });

    return timeLeft;
};

export function secondsToDHms(d, shortLabels = false) {
    d = Number(d);
    var days = Math.floor(d / (3600 * 24));
    var h = Math.floor((d % (3600 * 24)) / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor(d % 60);

    var dDisplay = days > 0 ? days + (shortLabels ? "D " : (days == 1 ? " day " : " days ")) : "";
    var hDisplay = h > 0 ? h + (shortLabels ? "H " : (h == 1 ? " hour " : " hours ")) : "";
    var mDisplay = m > 0 ? m + (shortLabels ? "M " : (m == 1 ? " minute " : " minutes ")) : "";
    var sDisplay = s > 0 ? s + (shortLabels ? "S" : (s == 1 ? " second" : " seconds")) : "";
    const arr = [dDisplay, hDisplay, mDisplay, sDisplay];
    
    return arr?.filter(item => item).join('').trim();
}

// Function to get the range time in seconds
export function getRangeTime(start: string, end: string) {
  const startTime = dayjs(start);
  const endTime = dayjs(end);
  return endTime.diff(startTime, 'second');
}

export default useCountdown;
